import {
  BANKING_SUB_PRODUCT_TYPES,
  INVESTING_SUB_PRODUCT_TYPES,
  PRODUCT_TYPES,
} from '@nerdwallet/marketplace/constants';
import {
  getProductType,
  getSubProductType,
} from '@nerdwallet/marketplace/selectors/common';

export const PRODUCT_TYPE_UNSTRUCTURED_VERTICAL = {
  AUTOINSURANCE: 'auto_insurance',
  TAXES: 'taxes',
  TRAVEL: 'travel',
  BANKING: 'banking',
  CREDITCARDS: 'credit_cards',
  INVESTING: 'investing',
  MORTGAGES: 'mortgages',
  PERSONALLOANS: 'personal_loans',
};

export const PRODUCT_TYPE_NAME_MAPPING = {
  [PRODUCT_TYPES.CREDIT_CARDS]: 'Card',
  [BANKING_SUB_PRODUCT_TYPES.CHECKING]: 'Account',
  [PRODUCT_TYPES.BANKING]: 'Bank',
  [BANKING_SUB_PRODUCT_TYPES.CD]: 'CD',
  [BANKING_SUB_PRODUCT_TYPES.SAVINGS]: 'Account',
  [BANKING_SUB_PRODUCT_TYPES.MONEY_MARKET]: 'Account',
  [INVESTING_SUB_PRODUCT_TYPES.BROKER]: 'Broker',
  [INVESTING_SUB_PRODUCT_TYPES.INVESTMENT_ADVISOR]: 'Robo-advisor',
  [PRODUCT_TYPES.PERSONAL_LOANS]: 'Lender',
  [PRODUCT_TYPES.EDUCATION_LOANS]: 'Lender',
};

export const getProductName = (entity) => {
  const productType = getProductType(entity);
  switch (productType) {
    case PRODUCT_TYPES.BANKING:
    case PRODUCT_TYPES.INVESTING:
      return (
        PRODUCT_TYPE_NAME_MAPPING[getSubProductType(entity)] ||
        PRODUCT_TYPE_NAME_MAPPING[productType]
      );

    default:
      return PRODUCT_TYPE_NAME_MAPPING[productType];
  }
};
